import { render, staticRenderFns } from "./ViewportOrtho.vue?vue&type=template&id=5ffbf814&scoped=true"
import script from "./ViewportOrtho.vue?vue&type=script&lang=js"
export * from "./ViewportOrtho.vue?vue&type=script&lang=js"
import style0 from "./ViewportOrtho.vue?vue&type=style&index=0&id=5ffbf814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffbf814",
  null
  
)

export default component.exports